import styled, {css, keyframes} from "styled-components"
import Flex from "@irati/ui/src/Flex"
import {H2} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"

interface StyledProps {
  startAnimation?: boolean
}

export const ReminderWrapper = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.white};
    border-radius: ${theme.spacing.one};
    box-shadow: 1px 2px 5px 0 rgb(0 0 0 / 10%);
    padding: ${theme.spacing.four} ${theme.spacing.three};
    margin-top: ${theme.spacing.five};
  `}
`

export const CalendarDay = styled(Flex)`
  border: 1px solid rgba(92, 92, 92, 0.1);
  width: 100px;
  height: 100px;
  margin: 32px auto 24px;
  border-radius: ${({theme}) => theme.spacing.one};
`

export const MonthSection = styled(Flex)`
  ${({theme}) => css`
    background-color: ${theme.colors.secondary1};
    color: ${theme.colors.greys.white};
    width: 100%;
    border-top-left-radius: ${theme.spacing.one};
    border-top-right-radius: ${theme.spacing.one};
    font-size: ${theme.spacing.two};
  `}
`

export const DateNumber = styled(H2)`
  font-family: ${({theme}) => theme.font.bold};
  line-height: 18px;
  margin-bottom: 11px;
  margin-top: 21px;
`

export const DateHours = styled(Flex)`
  font-size: 20px;
  line-height: 24px;
  color: ${({theme}) => theme.colors.greys.black};
`

export const Text = styled.span`
  margin-left: 10px;
`

const shake = keyframes`
  0%, 100% {
    transform: rotate(0deg);
  }

  20%, 60% {
    transform: rotate(20deg);
  }

  40%, 80% {
    transform: rotate(-20deg);
  }
`

export const AnimatedButton = styled(Button)<StyledProps>`
  ${({startAnimation}) => css`
    text-align: center;
    ${Icon} {
      animation: ${startAnimation ? shake: ""} 1.2s ease-in-out infinite;
    }
  `}
`
